import React from 'react'

interface TmaLogoProps {
  height?: number
  /** Main letter colour */
  color?: string
  /** Shadow plane colour */
  accentColor?: string
}

// "TMA" wordmark. The polygons are traced pixel-exact from the reference
// artwork (public/tma-logo.png) via contour extraction, so this is a faithful
// vector copy: T with a drooping left arm and a dark right arm, M with a dark
// centre mass, A with a dark lower-left leg and a notched base.
// Recolour via the props (e.g. blue: color='#4a7dff' accentColor='#1d3fae').
const TmaLogo: React.FC<TmaLogoProps> = ({ height = 24, color = '#ff6f03', accentColor = '#c54500' }) => (
  <svg height={height} viewBox='0 0 240 85' xmlns='http://www.w3.org/2000/svg' role='img' aria-label='TMA' style={{ display: 'block' }}>
    {/* T */}
    <polygon points='5,2 53,2 55,4 54,79 26,78 26,6 3,36 4,3' fill={color} />
    <polygon points='54,2 75,2 75,34 55,3' fill={accentColor} />
    <polygon points='76,2 77,36 76,3' fill={color} />

    {/* M + A, pulled left so the T/M gap closes */}
    <g transform='translate(-5 0)'>
      <polygon points='82,3 113,4 119,27 121,26 104,78 82,4' fill={color} />
      <polygon points='128,3 156,3 156,79 128,79 128,4' fill={color} />
      <polygon points='82,8 103,79 127,9 127,79 82,79 82,9' fill={accentColor} />
      <polygon points='198,5 240,81 198,81 191,71 188,76 191,70 176,44 197,6' fill={color} />
      <polygon points='176,45 190,70 186,78 157,79 175,46' fill={accentColor} />
    </g>
  </svg>
)

export default TmaLogo
